module.exports = __webpack_public_path__ + "a99114c423ca9e692879b1d3d903a063.svg";